export default "__VITE_ASSET__38b0ef12__"